import Vue from 'vue'
import Router from 'vue-router'

import store from '../store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_URL_FRONT,
  routes: [
    {
      path: '/questions',
      name: 'questionsList',
      component: () => import('@/views/questions/List.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/modification/likert/:id',
      name: 'questionLikertModification',
      component: () => import('@/views/questions/LikertModification.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/creation/likert/:id',
      name: 'questionLikertClone',
      component: () => import('@/views/questions/LikertCreation.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/creation/likert',
      name: 'questionLikertCreation',
      component: () => import('@/views/questions/LikertCreation.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/modification/open/:id',
      name: 'questionOpenModification',
      component: () => import('@/views/questions/OpenModification.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/creation/open/:id',
      name: 'questionOpenClone',
      component: () => import('@/views/questions/OpenCreation.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/creation/open',
      name: 'questionOpenCreation',
      component: () => import('@/views/questions/OpenCreation.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/modification/mcq/:id',
      name: 'questionMcqModification',
      component: () => import('@/views/questions/MCQModification.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/creation/mcq/:id',
      name: 'questionMcqClone',
      component: () => import('@/views/questions/MCQCreation.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/question/creation/mcq',
      name: 'questionMcqCreation',
      component: () => import('@/views/questions/MCQCreation.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/questionnaires',
      name: 'questionnaireList',
      component: () => import('@/views/questionnaires/List.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/questionnaire/initialisation',
      name: 'questionnaireInit',
      component: () => import('@/views/questionnaires/InitQuestionnaire.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/questionnaire/publication/:id',
      name: 'questionnairePublication',
      component: () => import('@/views/questionnaires/InitQuestionnaire.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/questionnaire/dupliquer/:id',
      name: 'questionnaireDuplication',
      component: () => import('@/views/questionnaires/InitQuestionnaire.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/questionnaire/:id',
      name: 'questionnaireCreation',
      component: () => import('@/views/questionnaires/CreateQuestionnaire.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/referentiel/selection',
      name: 'repositorySelect',
      component: () => import('@/views/repository/Select.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/referentiel',
      name: 'repositoryDetail',
      component: () => import('@/views/repository/Detail.vue'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/utilisateur/questionnaires',
      name: 'userQuestionnaireTemplate',
      component: () => import('@/views/appUser/questionnaires/Template'),
      children: [
        {
          path: '/utilisateur/questionnaire/:id',
          name: 'userQuestionnairePass',
          component: () => import('@/views/appUser/questionnaires/QuestionnairePass'),
        },
        {
          path: '/utilisateur/resultats/:id',
          name: 'user_results',
          component: () => import('@/views/appUser/questionnaires/Results'),
        },
        {
          path: '/utilisateur/questionnaires',
          name: 'home_user',
          component: () => import('@/views/appUser/questionnaires/Home'),
        },
      ],
    },
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/base/GestionnaireHome'),
      meta: { authorization: 'air_gestionnaire' },
    },
    {
      path: '/auth/cas/logout',
      name: 'cas_authentication_logout',
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  let accessToken = window.localStorage.getItem('JWT__access__token')
  if (!accessToken) {
    next() // let proceed to authentication
  } else {
    await store.dispatch('User/loadUser') // wait for authentication to be completed

    const userStaff = store.getters['User/user'].isStaff
    const routeAuthorizationNecessary = to.meta.authorization === 'air_gestionnaire'

    if (!routeAuthorizationNecessary) {
      next()
    } else if (routeAuthorizationNecessary && !userStaff) {
      next({ name: 'home_user' })
    } else {
      const repositoryId = window.sessionStorage.getItem('repository__id')
      const selectedRepository = store.getters['Repositories/repositorySelected']

      if (selectedRepository || to.name === 'repositorySelect') {
        next()
      } else {
        await store.dispatch('Repositories/selectRepository', repositoryId)
        store.getters['Repositories/repositorySelected']
        ? next()
        : next({ name: 'repositorySelect' })
      }
    }
  }
})

export default router
